import React from 'react';
import { Grid } from '@material-ui/core';
import DealsGlobalReport from './scenes/DealsGlobalReport';
import EmployeeReport from './scenes/EmployeeReport';

const CommercialReport = () => {
  return (
    <Grid container spacing={6}>
      <Grid item xs={12}>
        <DealsGlobalReport />
      </Grid>

      <Grid item xs={12}>
        <EmployeeReport />
      </Grid>
    </Grid>
  );
};

export default CommercialReport;
